var paymentCardConstants = {
  VISA: {
    label: 'Visa',
    number: '4111111111111111'
  },
  AMEX: {
    label: 'Amex',
    number: '34000000000000'
  },
  MASTERCARD: {
    label: 'Mastercard',
    number: '5453010000000000'
  },
  ANY_DAY: {
    label: 'Any Day',
    number: '5373704000020011'
  },
  NEW_DAY: {
    label: 'New Day',
    number: '5373702901260033'
  }
};
export { paymentCardConstants as default };